// file.service.ts
import { Injectable } from '@angular/core';
import { HttpApiService } from './http-api.service';
import { saveAs } from 'file-saver';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FileApiService {
  constructor(private httpApiService: HttpApiService) { }

  private handleFileDownload(response: Blob, filename: string, mimeType: string): void {
    if (response) {
      saveAs(response, filename);
    } else {
      console.error('No file data available to save.');
    }
  }

  public downloadPDF(cookies: string, endpoint: string, params?: any): void {
    this.httpApiService.get(endpoint, params, cookies, 'blob').pipe(
      catchError(error => {
        console.error('Download PDF failed', error);
        return of(null);
      })
    ).subscribe(response => {
      if (response instanceof Blob) {
        const filename = 'export.pdf';
        this.handleFileDownload(response, filename, 'application/pdf');
      } else {
        console.error('Unexpected response type', response);
      }
    });
  }

  public downloadExcel(cookies: string, endpoint: string, params?: any): void {
    this.httpApiService.get(endpoint, params, cookies, 'blob').pipe(
      catchError(error => {
        console.error('Download Excel failed', error);
        return of(null);
      })
    ).subscribe(response => {
      if (response instanceof Blob) {
        const filename = 'export.xls';
        this.handleFileDownload(response, filename, 'application/vnd.ms-excel');
      } else {
        console.error('Unexpected response type', response);
      }
    });
  }
}
